var map = {
	"./blacktea.jpg": 37,
	"./darktea.jpg": 38,
	"./earlgreytea.jpg": 39,
	"./greentea.jpg": 40,
	"./herbaltea.jpg": 41,
	"./masalatea.jpg": 42,
	"./matchatea.jpg": 43,
	"./oolongtea.jpg": 44,
	"./puertea.jpg": 45,
	"./rooibostea.jpg": 46,
	"./senchatea.jpg": 47,
	"./whitetea.jpg": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;